import { Directive, Input, ElementRef } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { StringHelper } from '../helpers/string-helper';

@Directive({
  selector: '[matBadgeIcon]'
})
export class MatBadgeIconDirective {
  @Input() matBadgeIcon: any;

  constructor(private el: ElementRef, private iconRegistry: MatIconRegistry) {}

  ngOnInit() {
    if (this.matBadgeIcon != null) {
      if (!StringHelper.isEmpty(this.matBadgeIcon.icon)) {
        this.iconRegistry.getNamedSvgIcon(this.matBadgeIcon.icon).subscribe(
          (svg: SVGElement) => {
            const sizeClass =
              this.matBadgeIcon.icon === 'exclamation'
                ? 'exclamation-icon'
                : 'smaller-icon';
            const transformClass = this.transformIconClass(
              this.matBadgeIcon.icon
            );
            this.setBadgeIcon(
              this.matBadgeIcon.borderColor,
              '#FFFFFF',
              `<mat-icon class="${sizeClass} ${transformClass} mat-icon mat-icon-badge">${svg.outerHTML}</mat-icon>`
            );
          },
          err => {
            this.setBadgeIcon(this.matBadgeIcon.borderColor);
          }
        );
      } else {
        this.setBadgeIcon(this.matBadgeIcon.borderColor);
      }
    }
  }

  private setBadgeIcon(
    borderColor: string,
    background?: string,
    innerHTML?: string
  ): void {
    const badge = this.el.nativeElement.querySelector('.mat-badge-content');
    badge.style.transform = 'translateY(5px)';
    badge.style.background = background == null ? '#DCDCDC' : background;
    badge.style.borderWidth = '2px';
    badge.style.borderStyle = 'solid';
    badge.style.borderRadius = '10px';
    badge.style.borderColor = borderColor;
    badge.innerHTML = innerHTML == null ? '' : innerHTML;
  }

  private transformIconClass(icon: string): string {
    switch (icon) {
      case 'send':
        return 'transform-send';
      case 'check-no-color':
        return 'transform-check-no-color';
      case 'double-check':
        return 'transform-double-check';
      case 'exclamation':
        return 'transform-exclamation';
      default:
        return 'transform-icon-default';
    }
  }
}
